export default __webpack_public_path__ + "static/ashley-4260bb735cbf28e0a2ab7010b9506f6b.png";